// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"2ac32657","1871":"f03fe579","2582":"5db51299","4242":"215c0ce0","4492":"1734ad37","5431":"7c62a987","5947":"6bda8de2","7520":"6bda8de2","8462":"55f53076"}[chunkId] + ".chunk.css";
};